import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import WatchFilledIcon from '@atlaskit/icon/glyph/watch-filled';

// @source
import { Messages } from '../../../../components';
import { Report as API } from '../../../../../server';

const initialState = {
  isLoading: false,
  message: false,
};

class PermissionButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      permission: this.props.permission(this.props.username),
    };
    this.unmount = false;
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle() {
    this.setState({
      isLoading: true,
      message: false,
    });

    API.permission({
      data: {
        report: this.props.report,
        users: [{
          username: this.props.username,
          permission: !this.state.permission,
        }],
      },
      success: () => {
        this.setStateUnmount({
          isLoading: false,
          permission: !this.state.permission,
        });
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              component="Modal"
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  render() {
    return (
      <div>
        <Button
          appearance="subtle"
          isLoading={this.state.isLoading}
          iconAfter={(
            <WatchFilledIcon
              primaryColor={this.state.permission ? '#8bc34a' : '#7c7c7c'}
              size="small"
            />
          )}
          onClick={this.onSubmitHandle}
        >
          {this.state.permission ? 'Allowed' : 'Not allowed'}
        </Button>
        {this.state.message}
      </div>
    );
  }
}

PermissionButton.propTypes = {
  permission: PropTypes.func.isRequired,
  report: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
};

export default PermissionButton;
